/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Account_Manageaccount1Inputs */

const he_extension_popup_account_manageaccount1 = /** @type {(inputs: Extension_Popup_Account_Manageaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נהל חשבון`)
};

const en_extension_popup_account_manageaccount1 = /** @type {(inputs: Extension_Popup_Account_Manageaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage account`)
};

/**
* | output |
* | --- |
* | "Manage account" |
*
* @param {Extension_Popup_Account_Manageaccount1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_account_manageaccount1 = /** @type {((inputs?: Extension_Popup_Account_Manageaccount1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Account_Manageaccount1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_account_manageaccount1(inputs)
	return en_extension_popup_account_manageaccount1(inputs)
});
export { extension_popup_account_manageaccount1 as "extension_popup_account_manageAccount" }